define.alias("ember-truth-helpers/helpers/and", "preview-grid/helpers/and");